import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncAbTests = Load(
  () => import(/* webpackChunkName: "ab-tests" */ './components/AbTests'),
  {},
  true,
);

export const abTestsRoute: RouteDescriptor = {
  id: 'ab-tests.overview',
  path: `${basePath}/ab-tests`,
  label: 'AB Tests Overview',
  audience: 'both',
  layout: 'navigational',
  module: 'ab-tests',
};

export const abTestsRoutes = [
  createNavigationalRoute({
    key: abTestsRoute.id,
    id: abTestsRoute.id,
    path: abTestsRoute.path,
    component: AsyncAbTests,
    handle: createRouteHandle(abTestsRoute),
    nonFixedNavbar: true,
  }),
];

export const abTestsRouteDescriptors = [abTestsRoute];

export default abTestsRoutes;
